import React, { useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { InputContainer } from '../form/InputContainer.js';
import { formModes, UserContext, urls, alfrescoTypes, formFieldTypes } from '../../constants.js';
import { Button, Accordion } from 'react-bootstrap';
import i18next from '../../i18n.js';
import FormField from '../form/FormField.js';
import TabsGroup from '../form/TabsGroup.js';
import TripSummary from '../forms/TripSummary.js';
import { isFieldVisibleOnStep, getFieldValue } from './DocumentHelpers.js';

const DocumentForm = (props) => {
    const userData = useContext(UserContext);
    const navigate = useNavigate();

    const onScheduleBtnClick = () => {
        const returnUrl = encodeURIComponent(document.location.pathname + document.location.search);
        navigate(`${urls.schedulePage}?return=${returnUrl}`);
    }

    const getVisibleFields = (fields, props) => (fields ?? []).filter(f => f.visible &&
        (!f.formModes || f.formModes.includes(props.formMode)) &&
        (!f.statuses || f.statuses.includes(props.properties['sx:dfState'])) &&
        isFieldVisibleOnStep(f, props.navigationIndex)
    );

    // formgroup is a card with the fields inside it, drawn without labels and separated by dividers
    const renderFormGroup = (group, props, disabled) => {
        return <div key={group.name} className={'form-group-card' + (group.className ? ` ${group.className}` : '')}>
            {getVisibleFields(group.fields, props).map(field => renderField(field, props, group.disabled || disabled, true))}
        </div>
    }

    // tabsgroup shows the fields of the tab selected by the user
    // formError відкриває вкладку, на якій лежить поле з помилкою перевірки
    const renderTabsGroup = (group, props, disabled) => {
        return <TabsGroup key={group.name} tabs={group.tabs} className={group.className} formError={props.formError}
            renderFields={(fields) => getVisibleFields(fields, props).map(field => renderField(field, props, group.disabled || disabled))} />
    }

    const renderGroup = (group, props, disabled) => {
        return <div className={'form-section' + (group.showBorder ? ' show-border' : '') + (group.className ? ` ${group.className}` : '')}>
            {(group.label || group.description) && <div className='form-section-header'>
                {group.label && <div className='form-section-label'>{group.label}</div>}
                {group.description && <div className='form-section-description'>{group.description}</div>}
            </div>}
            <div className='form-section-content'>
                {getVisibleFields(group.fields, props).map(field => renderField(field, props, group.disabled || disabled))}
            </div>
        </div>
    }

    const renderField = (field, props, disabled = false, insideFormGroup = false) => {
        if (field.type === formFieldTypes.group) {
            return renderGroup(field, props, disabled);
        }
        else if (field.type === formFieldTypes.formGroup) {
            return renderFormGroup(field, props, disabled);
        }
        else if (field.type === formFieldTypes.tabsGroup) {
            return renderTabsGroup(field, props, disabled);
        }
        else if (field.type === formFieldTypes.tripSummary) {
            // підсумку потрібні всі властивості документа і словники полів форми
            return <TripSummary key={field.name} properties={props.properties} fields={props.form.fields} />;
        }
        else {
            // inside formgroup the label is shown as a placeholder of the field itself
            const settings = insideFormGroup ? { ...field, placeholder: field.placeholder ?? field.label } : field;
            const value = getFieldValue(field, props.properties);
            return <div key={field?.name} name={field.name} className={`form-group ${field.type}-field ${field.className ? field.className : ''}`}>
                <InputContainer {...settings} hideLabel={insideFormGroup} check={props.submitted} required={(field.required && props.formMode !== formModes.read && !disabled) || field.alwaysRequired} value={value}>
                    <FormField settings={settings} value={value} onChange={props.onChange} formMode={disabled ? formModes.read : props.formMode} submitted={props.submitted} navigationIndex={props.navigationIndex} />
                </InputContainer>
            </div>
        }
    }

    const getAccordionHeader = () => {
        let result = '';
        switch (props.type) {
            case alfrescoTypes.vacationClaim:
                result = i18next.t('document.vacationAccordionHeader');
                break;
            case alfrescoTypes.businessTrip:
                result = i18next.t('document.businessTripAccordionHeader');
                break;
            case alfrescoTypes.certification:
                result = i18next.t('document.certificationAccordionHeader');
                break;
            case alfrescoTypes.details:
                result = i18next.t('document.detailsAccordionHeader');
                break;
            case alfrescoTypes.travelLetterAuto:
                result = i18next.t('document.travelLetterAutoAccordionHeader');
                break;
            case alfrescoTypes.advanceReport:
                result = i18next.t('document.advanceReportAccordionHeader');
        }
        return result;
    }

    return <div id={'doc_form_' + props.id} className={`document-form ${props?.type?.replace('sx:', '') ?? ''}`}>
        <Accordion className={'root-accordion' + (props.showAccordion ? '' : ' hide-collapse')} >
            <Accordion.Item eventKey="0">
                <Accordion.Header>{getAccordionHeader()}</Accordion.Header>
                <Accordion.Body>
                    <div className="row">
                        {props.form.fields && getVisibleFields(props.form.fields, props).map((item) => renderField(item, props))}
                        {props.isTask && userData?.isHead && props.type === alfrescoTypes.vacationClaim &&
                            <div className='form-group'>
                                <Button variant="secondary schedule-btn" onClick={onScheduleBtnClick}>{i18next.t("calendar.scheduleBtnText")}</Button>
                            </div>
                        }
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    </div>
}

export default DocumentForm;